import { TbArrowLeft, TbCheck } from "react-icons/tb";
import { Button } from "@/components/Button";
import { NumberInput } from "@/components/form/NumberInput";
import { useSubmit } from "@/submit/SubmitProvider";
import styles from "../PageSubmit.module.css";

export function StatementVerify() {
  const { form, back, next, canProceed } = useSubmit();
  const { control } = form;

  return (
    <div>
      <h2 className={styles.heading}>Current mortgage details</h2>
      <NumberInput
        control={control}
        name="balance"
        label="Outstanding balance ($)"
        placeholder="Outstanding balance"
      />

      <NumberInput
        control={control}
        dp={4}
        name="interestRate"
        label="Interest rate (%)"
        placeholder="Interest rate"
      />

      <NumberInput
        control={control}
        name="escrowBalance"
        label="Escrow balance"
        placeholder="Current escrow balance"
      />

      <h2 className={styles.heading}>Monthly payments</h2>
      <NumberInput
        control={control}
        dp={4}
        name="principal"
        label="Principal payment ($)"
        placeholder="Principal payment"
      />

      <NumberInput
        control={control}
        dp={4}
        name="interest"
        label="Interest payment ($)"
        placeholder="Interest payment"
      />

      <NumberInput
        control={control}
        dp={4}
        name="escrow"
        label="Escrow payment ($)"
        placeholder="Escrow payment"
      />

      <div className={styles.actions}>
        <Button icon={TbArrowLeft} onClick={back} variant="ghost">
          Back
        </Button>
        <Button icon={TbCheck} onClick={next} disabled={!canProceed}>
          Confirm
        </Button>
      </div>
    </div>
  );
}
